import { render, staticRenderFns } from "./TickEmissions.vue?vue&type=template&id=0319337e&"
import script from "./TickEmissions.vue?vue&type=script&lang=js&"
export * from "./TickEmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports